
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Page404'
})
export default class extends Vue {
  private message = '我们找不到你要找的那页'
}
